(() => {
  'use strict';

  if (window.__goodnessTeaCartPageLoaded) {
    return;
  }

  window.__goodnessTeaCartPageLoaded = true;

  const IS_THEME_EDITOR = Boolean(
    window.Shopify?.designMode
  );

  const RECOMMENDATION_CACHE_TTL_MS =
    5 * 60 * 1000;

  const RECOMMENDATION_PRODUCT_LIMIT = 20;
  const RECOMMENDATION_REQUEST_LIMIT = 10;

  const MAX_RECOMMENDATION_SEEDS =
    IS_THEME_EDITOR ? 1 : 3;

  const quantityTimers = new Map();
  const recommendationCache = new Map();

  let toastTimer = null;

  function clearQuantityTimers() {
    quantityTimers.forEach((timer) => {
      window.clearTimeout(timer);
    });

    quantityTimers.clear();
  }

  function getSubscribeFunction() {
    if (
      typeof window.subscribe ===
      'function'
    ) {
      return window.subscribe;
    }

    if (
      typeof subscribe ===
      'function'
    ) {
      return subscribe;
    }

    return null;
  }

  function getPublishFunction() {
    if (
      typeof window.publish ===
      'function'
    ) {
      return window.publish;
    }

    if (
      typeof publish ===
      'function'
    ) {
      return publish;
    }

    return null;
  }

  function getCartUpdateEvent() {
    if (
      window.PUB_SUB_EVENTS?.cartUpdate
    ) {
      return window.PUB_SUB_EVENTS
        .cartUpdate;
    }

    if (
      typeof PUB_SUB_EVENTS !==
        'undefined' &&
      PUB_SUB_EVENTS?.cartUpdate
    ) {
      return PUB_SUB_EVENTS
        .cartUpdate;
    }

    return null;
  }

  function publishCartUpdate(
    source,
    cartData,
    productVariantId = ''
  ) {
    const publishFunction =
      getPublishFunction();

    const cartUpdateEvent =
      getCartUpdateEvent();

    if (
      !publishFunction ||
      !cartUpdateEvent ||
      !cartData
    ) {
      return;
    }

    publishFunction(
      cartUpdateEvent,
      {
        source,
        productVariantId:
          String(
            productVariantId || ''
          ),

        cartData,
      }
    );
  }

  async function readJSONResponse(
    response
  ) {
    try {
      return await response.json();
    } catch (error) {
      return {};
    }
  }

  function getRequestErrorMessage(
    response,
    data,
    fallbackMessage
  ) {
    if (response.status === 429) {
      return 'The cart is temporarily busy. Please wait a moment and try again.';
    }

    const errorValue =
      data?.description ||
      data?.message ||
      data?.errors;

    if (
      typeof errorValue ===
        'string' &&
      errorValue.trim()
    ) {
      return errorValue;
    }

    if (
      Array.isArray(errorValue) &&
      errorValue.length
    ) {
      return errorValue
        .map(String)
        .join(' ');
    }

    return fallbackMessage;
  }

  function cartPageSections() {
    const items =
      document.getElementById('main-cart-items');

    const footer =
      document.getElementById('main-cart-footer');

    const recommendations =
      document.getElementById('main-cart-recommendations');

    return [
      {
        domId: 'main-cart-items',
        section: items?.dataset.id,
        selector: '.js-contents',
      },
      {
        domId: 'main-cart-footer',
        section: footer?.dataset.id,
        selector: '.js-contents',
      },
      {
        domId: 'main-cart-recommendations',
        section: recommendations?.dataset.id,
        selector: '.js-contents',
      },
      {
        domId: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ].filter((entry) => entry.section);
  }

  function sectionInnerHTML(html, selector) {
    if (!html) return null;

    const parsed =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const source =
      parsed.querySelector(selector);

    return source
      ? source.innerHTML
      : null;
  }

  function renderCartPageSections(
    state,
    options = {}
  ) {
    if (!state?.sections) return;

    clearQuantityTimers();

    const preserveScroll =
      options.preserveScroll !== false;

    const scrollTop =
      preserveScroll
        ? window.scrollY
        : 0;

    cartPageSections().forEach(
      (entry) => {
        const html =
          state.sections[entry.section];

        if (!html) return;

        const root =
          document.getElementById(
            entry.domId
          );

        if (!root) return;

        const target =
          root.querySelector(
            entry.selector
          ) || root;

        const replacement =
          sectionInnerHTML(
            html,
            entry.selector
          );

        if (replacement !== null) {
          target.innerHTML =
            replacement;
        }
      }
    );

    const empty =
      Number(state.item_count) === 0;

    document
      .querySelector('cart-items')
      ?.classList.toggle(
        'is-empty',
        empty
      );

    document
      .getElementById(
        'main-cart-footer'
      )
      ?.classList.toggle(
        'is-empty',
        empty
      );

    document
      .getElementById(
        'main-cart-recommendations'
      )
      ?.classList.toggle(
        'is-empty',
        empty
      );

    requestAnimationFrame(() => {
      if (preserveScroll) {
        window.scrollTo({
          top: scrollTop,
          behavior: 'auto',
        });
      }

      if (options.toastMessage) {
        showToast(
          options.toastMessage
        );
      }
    });
  }

  function showToast(message) {
    if (!message) return;

    let toast =
      document.querySelector(
        '.gt-cart-page-toast'
      );

    if (!toast) {
      toast =
        document.createElement('div');

      toast.className =
        'gt-cart-page-toast';

      toast.setAttribute(
        'role',
        'status'
      );

      toast.setAttribute(
        'aria-live',
        'polite'
      );

      document.body.appendChild(toast);
    }

    clearTimeout(toastTimer);

    toast.textContent = message;

    toast.classList.add(
      'is-visible'
    );

    toastTimer =
      window.setTimeout(() => {
        toast.classList.remove(
          'is-visible'
        );
      }, 2400);
  }

  function normaliseCodes(codes) {
    const unique =
      new Map();

    codes.forEach((code) => {
      const cleaned =
        String(code || '').trim();

      if (!cleaned) return;

      unique.set(
        cleaned.toLowerCase(),
        cleaned
      );
    });

    return Array.from(
      unique.values()
    );
  }

  async function updateDiscountCodes(
    codes
  ) {
    const root =
      window.Shopify?.routes?.root ||
      '/';

    const sections =
      cartPageSections();

    const response =
      await fetch(
        `${root}cart/update.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest',
          },

          body: JSON.stringify({
            discount:
              normaliseCodes(
                codes
              ).join(','),

            sections:
              sections.map(
                (entry) =>
                  entry.section
              ),

            sections_url:
              window.location.pathname,
          }),
        }
      );

    const data =
      await readJSONResponse(
        response
      );

    if (
      !response.ok ||
      data.errors ||
      data.status
    ) {
      throw new Error(
        getRequestErrorMessage(
          response,
          data,
          'The discount could not be updated.'
        )
      );
    }

    return data;
  }

  function fastQuantityClick(event) {
    if (
      !(event.target instanceof Element)
    ) {
      return;
    }

    const button =
      event.target.closest(
        '.gt-cart-page-quantity .quantity__button'
      );

    if (
      !button ||
      button.disabled ||
      button.getAttribute(
        'aria-disabled'
      ) === 'true'
    ) {
      return;
    }

    const cartItems =
      button.closest('cart-items');

    const input =
      button
        .closest('quantity-input')
        ?.querySelector(
          '.quantity__input'
        );

    if (
      !cartItems ||
      !input ||
      typeof cartItems.updateQuantity !==
        'function'
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const current =
      Number.parseInt(
        input.value,
        10
      ) || 0;

    const step =
      Math.max(
        1,
        Number.parseInt(
          input.step,
          10
        ) || 1
      );

    const minimum =
      Math.max(
        1,
        Number.parseInt(
          input.dataset.min,
          10
        ) || 1
      );

    const maximum =
      input.max !== ''
        ? Number.parseInt(
            input.max,
            10
          )
        : Number.POSITIVE_INFINITY;

    let next = current;

    if (button.name === 'plus') {
      next = current + step;

      if (
        Number.isFinite(maximum)
      ) {
        next = Math.min(
          next,
          maximum
        );
      }
    }

    if (button.name === 'minus') {
      const proposed =
        current - step;

      next =
        minimum > 1 &&
        proposed < minimum
          ? current
          : Math.max(0, proposed);
    }

    if (next === current) {
      return;
    }

    input.value =
      String(next);

    input.dispatchEvent(
      new Event('input', {
        bubbles: true,
      })
    );

    const line =
      input.dataset.index;

    const existing =
      quantityTimers.get(line);

    if (existing) {
      clearTimeout(existing);
    }

    quantityTimers.set(
      line,
      window.setTimeout(() => {
        quantityTimers.delete(line);

        if (
          !input.isConnected ||
          !cartItems.isConnected
        ) {
          return;
        }

        const latest =
          Number.parseInt(
            input.value,
            10
          );

        cartItems.updateQuantity(
          line,
          Number.isFinite(latest)
            ? latest
            : next,
          button.name,
          input.dataset
            .quantityVariantId
        );
      }, 60)
    );
  }

  document.addEventListener(
    'click',
    fastQuantityClick,
    true
  );

  class CartPageDiscount extends HTMLElement {
    constructor() {
      super();

      this.onSubmit =
        this.onSubmit.bind(this);

      this.onClick =
        this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener(
        'submit',
        this.onSubmit
      );

      this.addEventListener(
        'click',
        this.onClick
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'submit',
        this.onSubmit
      );

      this.removeEventListener(
        'click',
        this.onClick
      );
    }

    getAppliedCodes() {
      const data =
        this.querySelector(
          '[data-applied-discount-codes]'
        );

      if (!data) return [];

      try {
        const codes =
          JSON.parse(
            data.textContent ||
              '[]'
          );

        return Array.isArray(codes)
          ? codes
              .map((code) =>
                String(code).trim()
              )
              .filter(Boolean)
          : [];
      } catch (error) {
        console.error(
          'Unable to read discount codes:',
          error
        );

        return [];
      }
    }

    onSubmit(event) {
      const form =
        event.target.closest(
          '[data-cart-page-discount-form]'
        );

      if (!form) return;

      event.preventDefault();

      this.apply(form);
    }

    onClick(event) {
      if (
        !(event.target instanceof Element)
      ) {
        return;
      }

      const button =
        event.target.closest(
          '[data-remove-discount-code]'
        );

      if (!button) return;

      event.preventDefault();

      this.remove(button);
    }

    async apply(form) {
      const input =
        form.querySelector(
          '[name="discount"]'
        );

      const button =
        form.querySelector(
          'button[type="submit"]'
        );

      const message =
        form.querySelector(
          '[data-discount-message]'
        );

      if (
        !input ||
        !button
      ) {
        return;
      }

      const code =
        input.value.trim();

      if (!code) {
        if (message) {
          message.textContent =
            'Enter a gift voucher or discount code.';

          message.classList.add(
            'is-error'
          );
        }

        input.focus();

        return;
      }

      button.disabled = true;

      message?.classList.remove(
        'is-success',
        'is-error'
      );

      if (message) {
        message.textContent = '';
      }

      try {
        const data =
          await updateDiscountCodes([
            ...this.getAppliedCodes(),
            code,
          ]);

        const matching =
          (
            data.discount_codes || []
          ).find(
            (discount) =>
              discount.code?.toLowerCase() ===
              code.toLowerCase()
          );

        const applied =
          matching
            ? matching.applicable !==
              false
            : false;

        renderCartPageSections(
          data,
          {
            preserveScroll: true,
          }
        );

        publishCartUpdate(
          'cart-page-discount',
          data
        );

        window.setTimeout(() => {
          const container =
            document.querySelector(
              '[data-cart-page-discount]'
            );

          const details =
            container?.querySelector(
              '.gt-cart-summary-details'
            );

          const newInput =
            container?.querySelector(
              '[name="discount"]'
            );

          const newMessage =
            container?.querySelector(
              '[data-discount-message]'
            );

          if (details) {
            details.open = true;
          }

          if (
            newInput &&
            !applied
          ) {
            newInput.value = code;
          }

          if (newMessage) {
            newMessage.textContent =
              applied
                ? 'Code applied successfully.'
                : 'That code is not valid for these items.';

            newMessage.classList.toggle(
              'is-success',
              applied
            );

            newMessage.classList.toggle(
              'is-error',
              !applied
            );
          }
        }, 80);
      } catch (error) {
        console.error(error);

        button.disabled = false;

        if (message) {
          message.textContent =
            error.message ||
            'The code could not be applied.';

          message.classList.add(
            'is-error'
          );
        }
      }
    }

    async remove(button) {
      if (
        button.disabled ||
        button.classList.contains(
          'is-loading'
        )
      ) {
        return;
      }

      const code =
        String(
          button.dataset.discountCode ||
            ''
        ).trim();

      if (!code) return;

      button.disabled = true;

      button.classList.add(
        'is-loading'
      );

      const remaining =
        this.getAppliedCodes().filter(
          (existing) =>
            existing.toLowerCase() !==
            code.toLowerCase()
        );

      try {
        const data =
          await updateDiscountCodes(
            remaining
          );

        renderCartPageSections(
          data,
          {
            preserveScroll: true,

            toastMessage:
              `${code} discount removed`,
          }
        );

        publishCartUpdate(
          'cart-page-discount',
          data
        );
      } catch (error) {
        console.error(error);

        button.disabled = false;

        button.classList.remove(
          'is-loading'
        );

        showToast(
          error.message ||
            'The discount could not be removed.'
        );
      }
    }
  }

  if (
    !customElements.get(
      'cart-page-discount'
    )
  ) {
    customElements.define(
      'cart-page-discount',
      CartPageDiscount
    );
  }

  class CartPageRecommendations extends HTMLElement {
    constructor() {
      super();

      this.abortController = null;
      this.cartUpdateUnsubscriber = null;
      this.scrollFrame = null;
      this.lastLoadedSeedKey = '';
      this.pendingLoadKey = '';

      this.onClick =
        this.onClick.bind(this);

      this.onChange =
        this.onChange.bind(this);

      this.onScroll =
        this.onScroll.bind(this);
    }

    connectedCallback() {
      this.addEventListener(
        'click',
        this.onClick
      );

      this.addEventListener(
        'change',
        this.onChange
      );

      this.viewport =
        this.querySelector(
          '[data-recommendations-viewport]'
        );

      this.viewport?.addEventListener(
        'scroll',
        this.onScroll,
        {
          passive: true,
        }
      );

      const subscribeFunction =
        getSubscribeFunction();

      const cartUpdateEvent =
        getCartUpdateEvent();

      if (
        subscribeFunction &&
        cartUpdateEvent
      ) {
        this.cartUpdateUnsubscriber =
          subscribeFunction(
            cartUpdateEvent,
            (event) => {
              if (
                event.source ===
                'cart-page-recommendations'
              ) {
                return;
              }

              this.syncFromCart(
                event.cartData
              );
            }
          );
      }

      this.load();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'click',
        this.onClick
      );

      this.removeEventListener(
        'change',
        this.onChange
      );

      this.viewport?.removeEventListener(
        'scroll',
        this.onScroll
      );

      this.abortController?.abort();

      if (this.scrollFrame) {
        window.cancelAnimationFrame(
          this.scrollFrame
        );

        this.scrollFrame = null;
      }

      this.cartUpdateUnsubscriber?.();

      this.cartUpdateUnsubscriber =
        null;

      this.abortController = null;
      this.pendingLoadKey = '';
    }

    getCartProductIds() {
      return Array.from(
        new Set(
          String(
            this.dataset
              .cartProductIds || ''
          )
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean)
        )
      );
    }

    getSeedIds() {
      const cartProductIds =
        this.getCartProductIds();

      if (cartProductIds.length) {
        return cartProductIds;
      }

      const fallbackId =
        String(
          this.dataset.productId || ''
        ).trim();

      return fallbackId
        ? [fallbackId]
        : [];
    }

    getSeedKey(seedIds = this.getSeedIds()) {
      return [...seedIds]
        .map(String)
        .sort()
        .join('|');
    }

    getCardVariantPrice(card) {
      const select =
        card?.querySelector(
          '[data-recommendation-variant]'
        );

      const selectedOption =
        select?.options[
          select.selectedIndex
        ];

      if (
        selectedOption?.dataset.price
      ) {
        return Number(
          selectedOption.dataset.price
        );
      }

      const addButton =
        card?.querySelector(
          '[data-recommendation-add]'
        );

      return Number(
        addButton?.dataset
          .variantPrice ||
        0
      );
    }

    refreshShippingBadges() {
      this.querySelectorAll(
        '[data-recommendation-card]'
      ).forEach((card) => {
        this.updateShippingBadge(
          card,
          this.getCardVariantPrice(
            card
          )
        );
      });
    }

    syncFromCart(cartData) {
      if (!cartData?.items) return;

      const shell =
        this.closest(
          '.gt-cart-page-recommendations-shell'
        );

      const isEmpty =
        !cartData.item_count;

      shell?.classList.toggle(
        'is-empty',
        isEmpty
      );

      if (isEmpty) {
        this.abortController?.abort();

        this.pendingLoadKey = '';
        this.hidden = true;

        return;
      }

      this.hidden = false;

      const productIds =
        Array.from(
          new Set(
            cartData.items
              .map(
                (item) =>
                  item.product_id
              )
              .filter(Boolean)
              .map(String)
          )
        );

      this.dataset.cartProductIds =
        productIds.join(',');

      this.dataset.productId =
        String(
          productIds[0] || ''
        );

      const freeShippingThreshold =
        Math.max(
          0,
          Number(
            this.dataset
              .freeShippingThreshold ||
              3500
          )
        );

      this.dataset.freeShippingRemaining =
        String(
          Math.max(
            freeShippingThreshold -
              Number(
                cartData.total_price ||
                  0
              ),
            0
          )
        );

      this.refreshShippingBadges();

      const nextSeedKey =
        this.getSeedKey(
          productIds
        );

      if (
        nextSeedKey ===
        this.lastLoadedSeedKey
      ) {
        this.updateCounter();

        return;
      }

      this.load();
    }

    onClick(event) {
      if (
        !(event.target instanceof Element)
      ) {
        return;
      }

      const add =
        event.target.closest(
          '[data-recommendation-add]'
        );

      if (add) {
        event.preventDefault();

        this.addProduct(add);

        return;
      }

      const scroll =
        event.target.closest(
          '[data-recommendation-scroll]'
        );

      if (scroll) {
        event.preventDefault();

        this.scrollByDirection(
          Number(
            scroll.dataset
              .recommendationScroll ||
              0
          )
        );
      }
    }

    onChange(event) {
      if (
        !(event.target instanceof Element)
      ) {
        return;
      }

      const select =
        event.target.closest(
          '[data-recommendation-variant]'
        );

      if (!select) return;

      const option =
        select.options[
          select.selectedIndex
        ];

      const card =
        select.closest(
          '[data-recommendation-card]'
        );

      const add =
        card?.querySelector(
          '[data-recommendation-add]'
        );

      const price =
        card?.querySelector(
          '[data-recommendation-price]'
        );

      const image =
        card?.querySelector(
          '[data-recommendation-image]'
        );

      if (add) {
        add.dataset.variantId =
          option.value;

        add.dataset.variantPrice =
          String(
            Number(
              option.dataset.price ||
                0
            )
          );
      }

      if (price) {
        price.textContent =
          this.formatMoney(
            Number(
              option.dataset.price
            )
          );
      }

      if (
        image &&
        option.dataset.image
      ) {
        image.src =
          option.dataset.image;
      }

      this.updateShippingBadge(
        card,
        Number(
          option.dataset.price
        )
      );
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame =
        requestAnimationFrame(() => {
          this.updateCounter();

          this.scrollFrame = null;
        });
    }

    async load() {
      const cartProductIds =
        this.getCartProductIds();

      const seedIds =
        this.getSeedIds();

      const seedKey =
        this.getSeedKey(
          seedIds
        );

      if (!seedIds.length) {
        this.abortController?.abort();

        this.pendingLoadKey = '';
        this.hidden = true;

        return;
      }

      if (
        seedKey ===
        this.lastLoadedSeedKey
      ) {
        this.refreshShippingBadges();
        this.updateCounter();

        return;
      }

      if (
        seedKey ===
          this.pendingLoadKey &&
        this.abortController
      ) {
        return;
      }

      this.abortController?.abort();

      const controller =
        new AbortController();

      this.abortController =
        controller;

      this.pendingLoadKey =
        seedKey;

      this.setAttribute(
        'aria-busy',
        'true'
      );

      try {
        const productMap =
          new Map();

        const limitedSeedIds =
          seedIds.slice(
            0,
            MAX_RECOMMENDATION_SEEDS
          );

        for (
          const productId
          of limitedSeedIds
        ) {
          for (
            const intent
            of [
              'related',
              'complementary',
            ]
          ) {
            if (
              productMap.size >=
              RECOMMENDATION_PRODUCT_LIMIT
            ) {
              break;
            }

            const products =
              await this.fetchProducts(
                productId,
                cartProductIds,
                intent,
                controller.signal
              );

            if (
              controller.signal.aborted
            ) {
              return;
            }

            products.forEach(
              (product) => {
                productMap.set(
                  String(product.id),
                  product
                );
              }
            );
          }

          if (
            productMap.size >=
            RECOMMENDATION_PRODUCT_LIMIT
          ) {
            break;
          }
        }

        if (
          controller.signal.aborted
        ) {
          return;
        }

        this.lastLoadedSeedKey =
          seedKey;

        this.render(
          Array.from(
            productMap.values()
          ).slice(
            0,
            RECOMMENDATION_PRODUCT_LIMIT
          )
        );
      } catch (error) {
        if (
          error.name !==
          'AbortError'
        ) {
          console.error(
            'Cart recommendations failed:',
            error
          );
        }

        if (
          !this.querySelector(
            '[data-recommendation-card]'
          )
        ) {
          this.hidden = true;
        }
      } finally {
        if (
          this.abortController ===
          controller
        ) {
          this.abortController =
            null;

          this.pendingLoadKey =
            '';

          this.setAttribute(
            'aria-busy',
            'false'
          );
        }
      }
    }

    async fetchProducts(
      productId,
      cartProductIds,
      intent,
      signal
    ) {
      const root =
        window.Shopify?.routes
          ?.root || '/';

      const cacheKey =
        `${root}|${productId}|${intent}`;

      const cached =
        recommendationCache.get(
          cacheKey
        );

      const cacheIsFresh =
        cached &&
        Date.now() -
          cached.createdAt <
          RECOMMENDATION_CACHE_TTL_MS;

      let products;

      if (cacheIsFresh) {
        products =
          cached.products;
      } else {
        const response =
          await fetch(
            `${root}recommendations/products.json?product_id=${encodeURIComponent(
              productId
            )}&limit=${RECOMMENDATION_REQUEST_LIMIT}&intent=${intent}`,
            {
              signal,

              headers: {
                Accept:
                  'application/json',
              },
            }
          );

        const data =
          await readJSONResponse(
            response
          );

        if (!response.ok) {
          const message =
            response.status === 429
              ? 'Shopify temporarily rate-limited the recommendations request.'
              : `Recommendations request failed with ${response.status}.`;

          throw new Error(message);
        }

        products =
          Array.isArray(
            data.products
          )
            ? data.products
            : [];

        recommendationCache.set(
          cacheKey,
          {
            createdAt: Date.now(),
            products,
          }
        );
      }

      if (signal?.aborted) {
        const abortError =
          new DOMException(
            'The recommendations request was cancelled.',
            'AbortError'
          );

        throw abortError;
      }

      const inCart =
        new Set(
          cartProductIds.map(String)
        );

      return products.filter(
        (product) => {
          const availableVariant =
            (
              product.variants || []
            ).some(
              (variant) =>
                variant.available
            );

          return (
            product.available &&
            availableVariant &&
            !inCart.has(
              String(product.id)
            )
          );
        }
      );
    }

    render(products) {
      const list =
        this.querySelector(
          '[data-recommendations-list]'
        );

      if (!list) {
        this.hidden = true;

        return;
      }

      if (!products.length) {
        list.innerHTML = '';
        this.hidden = true;

        return;
      }

      list.innerHTML =
        products
          .map((product) =>
            this.buildCard(product)
          )
          .filter(Boolean)
          .join('');

      this.hidden = false;

      this.viewport =
        this.querySelector(
          '[data-recommendations-viewport]'
        );

      requestAnimationFrame(() => {
        this.refreshShippingBadges();
        this.updateCounter();
      });
    }

    buildCard(product) {
      const variants =
        (
          product.variants || []
        ).filter(
          (variant) =>
            variant.available
        );

      if (!variants.length) {
        return '';
      }

      const first =
        variants[0];

      const productUrl =
        product.url ||
        `/products/${product.handle}`;

      const image =
        this.getProductImage(
          product,
          first
        );

      const remaining =
        Number(
          this.dataset
            .freeShippingRemaining ||
            0
        );

      const unlocks =
        remaining > 0 &&
        Number(first.price) >=
          remaining;

      const variantControl =
        variants.length > 1
          ? `
            <label
              class="visually-hidden"
              for="CartPage-Recommendation-${product.id}"
            >
              Choose an option
            </label>

            <select
              id="CartPage-Recommendation-${product.id}"
              class="gt-cart-page-recommendation__select"
              data-recommendation-variant
            >
              ${variants
                .map(
                  (variant) => `
                    <option
                      value="${this.escapeAttribute(
                        variant.id
                      )}"
                      data-price="${Number(
                        variant.price
                      )}"
                      data-image="${this.escapeAttribute(
                        this.getProductImage(
                          product,
                          variant
                        )
                      )}"
                    >
                      ${this.escapeHTML(
                        variant.public_title ||
                          variant.title
                      )}
                    </option>
                  `
                )
                .join('')}
            </select>
          `
          : first.public_title
            ? `
              <div class="gt-cart-page-recommendation__single-variant">
                ${this.escapeHTML(
                  first.public_title
                )}
              </div>
            `
            : '';

      return `
        <article
          class="gt-cart-page-recommendation"
          data-recommendation-card
        >
          <a
            class="gt-cart-page-recommendation__image-link"
            href="${this.escapeAttribute(
              productUrl
            )}"
          >
            <img
              class="gt-cart-page-recommendation__image"
              data-recommendation-image
              src="${this.escapeAttribute(
                image
              )}"
              alt="${this.escapeAttribute(
                product.title
              )}"
              width="176"
              height="176"
              loading="lazy"
            >
          </a>

          <div class="gt-cart-page-recommendation__content">
            <a
              class="gt-cart-page-recommendation__title"
              href="${this.escapeAttribute(
                productUrl
              )}"
            >
              ${this.escapeHTML(
                product.title
              )}
            </a>

            ${variantControl}

            <span
              class="gt-cart-page-recommendation__unlock"
              data-free-shipping-unlock
              ${
                unlocks
                  ? ''
                  : 'hidden'
              }
            >
              Unlocks free shipping
            </span>
          </div>

          <div
            class="gt-cart-page-recommendation__price"
            data-recommendation-price
          >
            ${this.escapeHTML(
              this.formatMoney(
                first.price
              )
            )}
          </div>

          <button
            type="button"
            class="gt-cart-page-recommendation__add"
            data-recommendation-add
            data-variant-id="${this.escapeAttribute(
              first.id
            )}"
            data-variant-price="${this.escapeAttribute(
              Number(first.price)
            )}"
            data-product-title="${this.escapeAttribute(
              product.title
            )}"
          >
            <span class="gt-cart-page-recommendation__add-label">
              + Add
            </span>

            <span
              class="gt-cart-page-recommendation__button-spinner"
              aria-hidden="true"
            ></span>
          </button>
        </article>
      `;
    }

    getStepWidth() {
      const card =
        this.querySelector(
          '[data-recommendation-card]'
        );

      const track =
        this.querySelector(
          '[data-recommendations-list]'
        );

      if (!card) return 1;

      const styles =
        track
          ? window.getComputedStyle(
              track
            )
          : null;

      const gap =
        Number.parseFloat(
          styles?.columnGap ||
            styles?.gap ||
            '0'
        ) || 0;

      return card.offsetWidth + gap;
    }

    currentIndex() {
      if (!this.viewport) {
        return 0;
      }

      return Math.max(
        0,
        Math.round(
          this.viewport.scrollLeft /
            this.getStepWidth()
        )
      );
    }

    scrollByDirection(direction) {
      if (
        !this.viewport ||
        !direction
      ) {
        return;
      }

      const total =
        this.querySelectorAll(
          '[data-recommendation-card]'
        ).length;

      const next =
        Math.min(
          Math.max(
            this.currentIndex() +
              direction,
            0
          ),
          Math.max(
            total - 1,
            0
          )
        );

      const reduceMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

      this.viewport.scrollTo({
        left:
          next *
          this.getStepWidth(),

        behavior:
          reduceMotion
            ? 'auto'
            : 'smooth',
      });
    }

    updateCounter() {
      const cards =
        this.querySelectorAll(
          '[data-recommendation-card]'
        );

      const counter =
        this.querySelector(
          '[data-recommendation-counter]'
        );

      const previous =
        this.querySelector(
          '[data-recommendation-scroll="-1"]'
        );

      const next =
        this.querySelector(
          '[data-recommendation-scroll="1"]'
        );

      if (
        !counter ||
        !cards.length
      ) {
        return;
      }

      const index =
        Math.min(
          this.currentIndex(),
          cards.length - 1
        );

      counter.textContent =
        `${index + 1} / ${cards.length}`;

      if (previous) {
        previous.disabled =
          index <= 0;
      }

      if (next) {
        next.disabled =
          index >= cards.length - 1;
      }
    }

    updateShippingBadge(
      card,
      price
    ) {
      const badge =
        card?.querySelector(
          '[data-free-shipping-unlock]'
        );

      if (!badge) return;

      const remaining =
        Number(
          this.dataset
            .freeShippingRemaining ||
            0
        );

      badge.hidden = !(
        remaining > 0 &&
        price >= remaining
      );
    }

    async addProduct(button) {
      if (
        button.disabled ||
        button.classList.contains(
          'is-loading'
        )
      ) {
        return;
      }

      const variantId =
        Number(
          button.dataset.variantId
        );

      if (!variantId) return;

      const title =
        button.dataset
          .productTitle ||
        'Product';

      const status =
        this.querySelector(
          '[data-recommendations-status]'
        );

      const sections =
        cartPageSections();

      const root =
        window.Shopify?.routes
          ?.root || '/';

      button.disabled = true;

      button.classList.add(
        'is-loading'
      );

      if (status) {
        status.textContent = '';
      }

      try {
        const response =
          await fetch(
            `${root}cart/add.js`,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest',
              },

              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                  },
                ],

                sections:
                  sections.map(
                    (entry) =>
                      entry.section
                  ),

                sections_url:
                  window.location.pathname,
              }),
            }
          );

        const data =
          await readJSONResponse(
            response
          );

        if (
          !response.ok ||
          data.status
        ) {
          throw new Error(
            getRequestErrorMessage(
              response,
              data,
              'This product could not be added.'
            )
          );
        }

        renderCartPageSections(
          data,
          {
            preserveScroll: true,

            toastMessage:
              `${title} added to your cart`,
          }
        );

        publishCartUpdate(
          'cart-page-recommendations',
          data,
          variantId
        );
      } catch (error) {
        console.error(error);

        button.disabled = false;

        button.classList.remove(
          'is-loading'
        );

        if (status) {
          status.textContent =
            error.message ||
            'This product could not be added.';
        }
      }
    }

    getProductImage(
      product,
      variant
    ) {
      const variantImage =
        variant?.featured_image;

      const productImage =
        product.featured_image;

      let source = '';

      if (
        typeof variantImage ===
        'string'
      ) {
        source = variantImage;
      } else if (
        variantImage?.src
      ) {
        source =
          variantImage.src;
      } else if (
        typeof productImage ===
        'string'
      ) {
        source = productImage;
      } else if (
        productImage?.url
      ) {
        source =
          productImage.url;
      } else if (
        productImage?.src
      ) {
        source =
          productImage.src;
      } else if (
        Array.isArray(
          product.images
        ) &&
        product.images.length
      ) {
        source =
          typeof product.images[0] ===
          'string'
            ? product.images[0]
            : product.images[0]
                ?.src || '';
      }

      if (!source) return '';

      return `${source}${
        source.includes('?')
          ? '&'
          : '?'
      }width=256`;
    }

    formatMoney(cents) {
      const value =
        Number(cents || 0) /
        100;

      const currency =
        this.dataset.currency ||
        window.Shopify?.currency
          ?.active ||
        'AUD';

      try {
        return new Intl.NumberFormat(
          document.documentElement
            .lang || 'en-AU',
          {
            style: 'currency',

            currency,

            currencyDisplay:
              'narrowSymbol',

            minimumFractionDigits: 2,
          }
        ).format(value);
      } catch (error) {
        return `$${value.toFixed(2)}`;
      }
    }

    escapeHTML(value = '') {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    escapeAttribute(value = '') {
      return this.escapeHTML(value);
    }
  }

  if (
    !customElements.get(
      'cart-page-recommendations'
    )
  ) {
    customElements.define(
      'cart-page-recommendations',
      CartPageRecommendations
    );
  }

  function handleCheckoutClick(event) {
    if (
      !(
        event.target instanceof
        Element
      )
    ) {
      return;
    }

    const button =
      event.target.closest(
        '[data-cart-page-checkout]'
      );

    if (!button) return;

    button.classList.add(
      'is-loading'
    );

    button.setAttribute(
      'aria-busy',
      'true'
    );

    const label =
      button.querySelector(
        '[data-checkout-label]'
      );

    if (label) {
      label.textContent =
        'Opening secure checkout…';
    }
  }

  function sectionContainsCartPage(
    section
  ) {
    if (
      !(section instanceof Element)
    ) {
      return false;
    }

    return Boolean(
      section.matches(
        [
          '.gt-cart-page-items-section',
          '.gt-cart-page-footer-section',
          '.gt-cart-page-recommendations-section',
        ].join(',')
      ) ||
        section.querySelector(
          [
            '#main-cart-items',
            '#main-cart-footer',
            '#main-cart-recommendations',
          ].join(',')
        )
    );
  }

  function handleSectionUnload(event) {
    if (
      sectionContainsCartPage(
        event.target
      )
    ) {
      clearQuantityTimers();
    }
  }

  function handlePageHide() {
    clearQuantityTimers();

    window.clearTimeout(
      toastTimer
    );

    recommendationCache.clear();
  }

  document.addEventListener(
    'click',
    handleCheckoutClick
  );

  document.addEventListener(
    'shopify:section:unload',
    handleSectionUnload
  );

  window.addEventListener(
    'pagehide',
    handlePageHide,
    {
      once: true,
    }
  );
})();